module.exports = __webpack_public_path__ + "img/Property 1=4x3, Property 2=TL - East Timor.e767d9a0.svg";